import { render, staticRenderFns } from "./ExcLink.vue?vue&type=template&id=dbd45d90&scoped=true&"
import script from "./ExcLink.vue?vue&type=script&lang=js&"
export * from "./ExcLink.vue?vue&type=script&lang=js&"
import style0 from "./ExcLink.vue?vue&type=style&index=0&id=dbd45d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd45d90",
  null
  
)

export default component.exports